<template>
  <div id="AboutMeImage2" :class="sectionClass">
    <img class="content" src="/static/about-me/s44.webp" />

    <StickMe name="2" size="35" left="-31" top="10" uk-parallax="x: 80%" />
    <StickMe name="17" size="20" left="-36" top="42" uk-parallax="x: 60%" />

    <StickMe name="17" size="24" left="134" top="15" uk-parallax="x: 40%" />
    <StickMe name="3" size="26" left="126" top="-10" uk-parallax="x: 50%" />
    <StickMe name="3" size="14" left="105" top="48" uk-parallax="x: 20%" />

    <StickMe name="43" size="38" left="41" top="76" uk-parallax="x: 100%" />
  </div>
</template>

<script>
import { isMobile } from '@/helpers'
import StickMe from './StickMe.vue'

export default {
  components: { StickMe },
  computed: {
    sectionClass() {
      return {
        section: !this.isMobile(),
        sectionMobile: this.isMobile(),
      }
    },
  },
  methods: {
    isMobile,
  },
}
</script>

<style lang="scss" scoped>
.section {
  width: 60%;
  padding-bottom: 50%;
}

.sectionMobile {
  width: 60%;
  padding-bottom: 70%;

  img {
    scale: 1.3;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeImage2.vue